import { ApiError } from '@/components/Functional/lib/request'

/**
 * バックエンドがメッセージを公開できないときに差し込む汎用文言。
 * `ApiExceptionListener::buildResponse()` / `isSafeToExposeMessage()` が返すもので、
 * 具体的な理由を含まないためユーザーには見せず、呼び出し側の i18n 文言へフォールバックさせる。
 */
const GENERIC_API_ERROR_MESSAGES: ReadonlySet<string> = new Set([
  'An error occurred.',
  'An internal server error occurred.',
  'エラーが発生しました。時間をおいて再度お試しください。',
  'サーバーエラーが発生しました。時間をおいて再度お試しください。',
  'リクエストの内容が正しくありません。',
])

/**
 * v2 API のエラーレスポンスから、ユーザーに提示してよいメッセージのみを取り出す。
 * レスポンス形式は `{ error: { code, message, details } }`（ApiExceptionListener / ErrorResponse）。
 * 一部のエンドポイントは `{ message }` を直接返すためこちらにも対応する。
 * 公開不可・空文字・ApiError 以外の場合は null を返す。
 */
export function extractApiErrorMessage(error: unknown): string | null {
  if (!(error instanceof ApiError)) return null

  const body = error.body as { error?: { message?: unknown }; message?: unknown } | undefined
  const message = typeof body?.error?.message === 'string' ? body.error.message : body?.message
  if (typeof message !== 'string' || message.length === 0) return null
  if (GENERIC_API_ERROR_MESSAGES.has(message)) return null

  return message
}
